import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CmsConfig, ConfigModule} from '@spartacus/core';
import {MediaModule} from '@spartacus/storefront';
import {CustomGenericLinkComponent} from './custom-generic-link.component';
import {CustomButtonSwitchModule} from "../../../../../custom/cms-components/content/custom-button-switch/custom-button-switch.module";

@NgModule({
  declarations: [CustomGenericLinkComponent],
  exports: [CustomGenericLinkComponent],
  imports: [
    CommonModule,
    RouterModule,
    MediaModule,
    CustomButtonSwitchModule,
    ConfigModule.withConfig({
      cmsComponents: {
        GenericLinkComponent: {
          component: CustomGenericLinkComponent,
        },
      },
    } as CmsConfig),
  ],
})
export class CustomGenericLinkModule {}
